import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RappiderQRCodeComponent } from './qr-code.component';
import { QRCodeModule } from 'angularx-qrcode';


@NgModule({
  declarations: [
    RappiderQRCodeComponent
  ],
  imports: [
    CommonModule,
    QRCodeModule
  ],
  exports: [
    RappiderQRCodeComponent
  ]
})
export class RappiderQRCodeModule { }
